import { NormalizedVoucher, Vehicle, VouchersCampaign } from '@esportal/portal-service';

export enum AlertType {
	Mantenimiento = 'mantenimiento',
	PreITV = 'pre-itv',
	EntregaIdeal = 'entrega-ideal',
	OneToOnePolo = 'OneToOnePolo',
	OneToOneID = 'OneToOneID',
	Touran = 'Touran',
	GolfGTI = 'GolfGTI',
	IDWeCharge = 'IDWeCharge',
	IDWeChargePostPedido = 'IDWeChargePostPedido',
	VWBook26_Participa = 'VWBook26_Participa',
	VWBook26_Participado = 'VWBook26_Participado',
	VWBook26_Agotado = 'VWBook26_Agotado',
	Masters26_Open = 'Masters26_Open',
	Masters26_Enrolled = 'Masters26_Enrolled',
	Masters26_NoWinner = 'Masters26_NoWinner',
	Masters26_Winner = 'Masters26_Winner',
	LaLiga26_Open = 'LaLiga26_Open',
	LaLiga26_Enrolled = 'LaLiga26_Enrolled',
	LaLiga26_NoWinner = 'LaLiga26_NoWinner',
	ElClasico26_Open = 'ElClasico26_Open',
	ElClasico26_Enrolled = 'ElClasico26_Enrolled',
	ElClasico26_NoWinner = 'ElClasico26_NoWinner',
	GTIDay26_Open = 'GTIDay26_Open',
	GTIDay26_Enrolled = 'GTIDay26_Enrolled',
	GTIDayVIP26_Open = 'GTIDayVIP26_Open',
	GTIDayVIP26_Enrolled = 'GTIDayVIP26_Enrolled',
	GTIDayVIP26_Full = 'GTIDayVIP26_Full',
	EscuelaSeguridadVW = 'EscuelaSeguridadVW',
	AlertaIncapto = 'AlertaIncapto',
}

export const VoucherToAlertMap: Record<VouchersCampaign, AlertType> = {
	[VouchersCampaign.ENTREGA_IDEAL]: AlertType.EntregaIdeal,
	[VouchersCampaign.OneToOne_Polo]: AlertType.OneToOnePolo,
	[VouchersCampaign.OneToOne_ID]: AlertType.OneToOneID,
	[VouchersCampaign.OneToOne_ID_Flotas]: AlertType.OneToOneID,
	[VouchersCampaign.IDWeChargePostPedido]: AlertType.IDWeChargePostPedido,
	[VouchersCampaign.EscuelaSeguridadVW]: AlertType.EscuelaSeguridadVW,
	[VouchersCampaign.AlertaIncapto]: AlertType.AlertaIncapto,
};

export interface Alert {
	type: AlertType;
	title: string;
	description: string;

	imageSrc?: string;
	videoSrc?: string;
	disclaimerText?: string;
}

interface VehicleWithAlerts {
	alertType: AlertType;
	voucher?: NormalizedVoucher;
	vehicle: Vehicle;
	priority?: number;
}

interface PersonWithAlerts {
	alertType: AlertType;
	voucher?: NormalizedVoucher;
	priority?: number;
}

export type CombinedAlert = VehicleWithAlerts | PersonWithAlerts;
